import builder from '../builder';
import InformationCircle from '../../streamline-icons/light/information-circle.svg';

export default builder('IconInformationCircleLight', InformationCircle);
